import React from "react";
import "../styles/tooltip.style.css";

export const CommonTooltip = ({ text, position = "top", children }) => {
  return (
    <span className="tooltip-wrapper">
      {children}
      <span className={`tooltip-box tooltip-${position}`}>{text}</span>
    </span>
  );
};
